export type LeafComponentLoader = () => Promise<any>;

export const leafComponents: Record<string, LeafComponentLoader> = {
  // Registrera custom-blad här, t.ex.:
  // BudgetIntro: () => import('@/components/gt-library/leaves/BudgetIntro.vue'),
};

export function getLeafComponentLoader(
  componentId: string,
): LeafComponentLoader | undefined {
  return leafComponents[componentId];
}
